<script>
export default {
    name: "ConfirmSelectForUse",

    props: {
        patient: Object,
        showModal: Boolean,
        cover: Object,
    },

    methods: {

        saveData() {
            this.$root.loading = true;
            this.$http.post(`Visits/SelectPatientInsuranceforUse`, this.cover).then(() => {
                this.$root.loading = false;
                this.$emit('refreshData');
                this.$emit('closeModal');
            }).catch(() => { this.$root.loading = false; });
        }
    }
}
</script>
<template>
    <tail-modal :show="showModal">
        <template v-slot:title>
          <h5 class="font-bold text-sm">Select for use</h5>
        </template>
        <template v-slot:modal-body>
          <div class="flex flex-col">
                  <button class="flex-1 btn-primary btn-sm" @click.prevent="saveData"><i class="fa fa-check"></i> Select For Use</button>
                  <button class="flex-1 btn-warning btn-sm mt-4" @click.prevent="$emit('closeModal')"><i class="fa fa-times"></i> Close</button>
          </div>
        </template>
        <template v-slot:modal-footer></template>
    </tail-modal> 
</template>
